import { IApiPromise } from "@/interfaces/responseData";
import { Assessment, Checklist } from "../apiRoutes/routes";
import api from "@/interceptors";
import { IAssessmentDetail } from "@/interfaces/assessments/IAssessmentDetails";

export const getDataChecklist = (): IApiPromise<IAssessmentDetail[]> =>
  api.get(Checklist.getChecklists);
export const getDataChecklistGroup = (
  checklistId: any,
  checklistGroupId: any,
): IApiPromise<any> =>
  api.get(
    Checklist.getChecklistGroup.replace(
      /:checklistId|:checklistGroupId/gi,
      (match) => {
        if (match === ":checklistId") return checklistId.toString();
        if (match === ":checklistGroupId") return checklistGroupId;
        return "";
      },
    ),
  );
export const getDataChecklistGroupAction = (
  checklistId: any,
  checklistGroupId: any,
): IApiPromise<any> =>
  api.get(
    Checklist.getChecklistGroupAction
      .replace(":checklistId", checklistId.toString())
      .replace(":checklistGroupId", checklistGroupId.toString()),
  );

export const getDataChecklistGroupTemplateAction = (
  groupTemplateId: any,
): IApiPromise<any> =>
  api.get(
    Checklist.getChecklistGroupTemplateAction.replace(
      ":groupTemplateId",
      groupTemplateId.toString(),
    ),
  );

export const getDataChecklistGroupSuggestedActions = (
  checklistId: any,
  checklistGroupTemplateId: any,
): IApiPromise<any> =>
  api.get(
    Checklist.getChecklistGroupSuggestedActions
      .replace(":checklistId", checklistId.toString())
      .replace(":groupTemplateId", checklistGroupTemplateId.toString()),
  );

export const getChecklistGroupMetrics = (
  checkListId: number,
  listGroupId: number[],
): IApiPromise<any> =>
  api.get(
    Checklist.getChecklistGroupMetrics.replace(
      ":checklistId",
      checkListId.toString(),
    ),
    {
      params: {
        checklistGroupIds: listGroupId,
        includeRiskDetails: true,
      },
    },
  );

export const getDataChecklistForecasts = async (
  checklistId: number,
): IApiPromise<any> =>
  await api.get(Checklist.getChecklistForecasts, {
    params: {
      checklistId,
    },
  });

export const deleteChecklistForecasts = async (data: {
  checklistId: number;
  forecastIds: number[];
}): IApiPromise<any> =>
  await api.delete(Checklist.getChecklistForecasts, {
    data,
  });

export const createChecklistForecasts = async (
  data:
    | {
        checklistId: number;
        checklistGroupIds: number[];
        forecastCompliance: number;
        forecastDate: string;
        notes?: string;
        description?: string;
      }
    | any,
): IApiPromise<any> => await api.post(Checklist.createChecklistForecast, data);

export const getChecklistGroups = (checkListId: number): IApiPromise<any> =>
  api.get(
    Checklist.getChecklistGroups.replace(
      ":checklistId",
      checkListId.toString(),
    ),
  );
export const createChecklistGroupMetrics = (
  checkListId: number,
  groupTemplateId: number,
): IApiPromise<any> =>
  api.post(
    Checklist.createChecklistGroupMetrics
      .replace(":checklistId", checkListId.toString())
      .replace(":groupTemplateId", groupTemplateId.toString()),
  );

export const getChecklistGroupTemplateMetrics = (
  checklistId: string,
  includeRisks = true,
): IApiPromise<{
  checklistId: number;
  groupMetrics: any[];
}> =>
  api.get(
    Assessment.getChecklistGroupTemplateMetrics
      .replace(":checklistId", checklistId.toString())
      .concat(`?includeRiskDetails=${includeRisks}`),
  );

export const addChecklistItemToExistChecklistItemGroup = (
  checklistItemGroupId: number,
  checklistItemIds: Array<number>,
): IApiPromise<any> =>
  api.put(Checklist.AddChecklistItemToExistChecklistItemGroup, {
    checklistItemGroupId,
    checklistItemIds,
  });
export const removeActionTable = (data: any): IApiPromise<any> =>
  api.put(
    Checklist.removeActionTable.replace(
      ":checklistId",
      data.checklistId.toString(),
    ),
    {
      checklistGroupIds: data.checklistGroupIds,
    },
  );

export const remoOrEditveStep = (
  checkListId: number,
  checklistGroupId: number,
  checklistGroupActionId: number,
  data: any,
): IApiPromise<any> =>
  api.put(
    Checklist.removeStep
      .replace(":checklistId", checkListId.toString())
      .replace(":checklistGroupId", checklistGroupId.toString())
      .replace(":actionId", checklistGroupActionId.toString()),
    data,
  );
export const addStep = (
  checkListId: number,
  checklistGroupId: number,
  data: any,
): IApiPromise<any> =>
  api.post(
    Checklist.addStep
      .replace(":checklistId", checkListId.toString())
      .replace(":checklistGroupId", checklistGroupId.toString()),
    data,
  );

export const getChecklistGroupTemplates = (): IApiPromise<any> =>
  api.get(Checklist.getChecklistItemGroupTemplates);

export const postChecklistGroup = (params): IApiPromise<any> =>
  api.post(Checklist.updateChecklistItemGroup, params);

export const putChecklistGroup = (params): IApiPromise<any> =>
  api.put(Checklist.updateChecklistItemGroup, params);

export const putChecklistSuggestedAction = (
  groupTemplateId,
  params,
): IApiPromise<any> =>
  api.put(
    Checklist.putChecklistSuggestedAction.replace(
      ":groupTemplateId",
      groupTemplateId.toString(),
    ),
    params,
  );

export const deleteChecklistItemGroup = (
  checklistItemGroupId: number,
  checklistItemIdsToDelete: Array<number>,
): IApiPromise<any> =>
  api.delete(Checklist.deleteChecklistGroupItems, {
    data: {
      checklistItemGroupId,
      checklistItemIdsToDelete,
    },
  });
